import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding: 40px 0;
`;

export const AuthorHeader = styled.div`
  display: flex;
  gap: 32px;
  margin-bottom: 48px;
  align-items: flex-start;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const AuthorImage = styled.div`
  width: 180px;
  height: 180px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  background: ${({ theme }) => theme.colors.bgSecondary};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid ${({ theme }) => theme.colors.border};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const AuthorImagePlaceholder = styled.div`
  font-size: 64px;
  color: ${({ theme }) => theme.colors.text.dark.little};
`;

export const AuthorInfo = styled.div`
  flex: 1;
`;

export const AuthorName = styled.h1`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.xxl};
  color: ${({ theme }) => theme.colors.text.dark.very};
  margin-bottom: 16px;
`;

export const AuthorBio = styled.p`
  font-size: ${({ theme }) => theme.typography.sizes.md};
  color: ${({ theme }) => theme.colors.text.dark.medium};
  line-height: 1.8;
`;

export const BooksSection = styled.div`
  margin-top: 16px;
`;

export const BooksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 24px;
`;
